<template>
  <task-page v-if="task_page_obj!=null" :prop_task_page_obj="task_page_obj" :prop_user_sites="userSites" :prop_user="login_user_name" :prop_user_roles="userRoles" />
</template>
<script>
  export default {
    name: 'task-master-gage',
    data() {
      return {
        function_name: 'Task Master Page',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        task_page_obj: null,
        userFunctions: null,
        userRoles: null,
        userSites: null,
        login_user_name: null,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
      }
    },
    created() {
      let self = this;
      self.checkLoggedIn();
      self.getTaskPage();
      //self.checkInMailGroup();
    },
    mounted: function () {
      let self = this;
    },
    computed: {
    },
    methods: {
      getTaskPage() {
        let self = this;
        let url = self.$root.baseUrl + '/task/back-end/task-id/' + self.$route.params.task_id;
        // /task/back-end/task-id/
        let request_data = {
          task_id: self.$route.params.task_id,
          site: self.userSites,
          login_user_name: self.login_user_name
        };


        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let task_page_obj = null;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            console.log(res);

            if (response.status === 200) {
              task_page_obj = JSON.parse(res['task_info']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.task_page_obj = task_page_obj;
            eventHub.$emit('loading', false);
          })
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');
        this.login_user_name = user_name

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;

        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/task-management/TaskMasterPage.vue